// ============================================
// 📋 FORMULÁRIO MULTI-IDS - form-multi-ids.js
// Suporta múltiplos formulários com IDs diferentes
// Form ID: 918917
// ============================================

(function initMultiForm() {
  console.log("🔵 [FORM MULTI] Inicializando sistema multi-formulários");
  
  const COOKIE_NAME = "utm_campaign";
  const COOKIE_DAYS = 30;
  const FORM_ID = "918917";
  
  // ==========================================
  // 🎯 ADICIONE TODOS OS IDs DE CONTAINERS AQUI
  // ==========================================
  const CONTAINER_IDS = [
    "#ATXN3MVBocWRUNGR3T__forms_inline_tyA7pN", // formulario assessor
  ];

  // Controle de instâncias processadas
  const processedForms = new WeakSet();

  // ==========================================
  // 🔧 FUNÇÕES AUXILIARES - UTM
  // ==========================================
  function setCookie(name, value, days) {
    if (!value) return;
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    console.log("🔵 [FORM MULTI] Cookie UTM salvo:", value);
  }

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find(c => c.startsWith(name + "="));
    return cookie ? decodeURIComponent(cookie.split("=")[1]) : "";
  }

  function getUTMValue() {
    const params = new URLSearchParams(window.location.search);
    const utmFromUrl = params.get("utm_campaign");
    
    let utmValue = "";
    if (utmFromUrl) {
      utmValue = utmFromUrl;
      setCookie(COOKIE_NAME, utmFromUrl, COOKIE_DAYS);
    } else {
      utmValue = getCookie(COOKIE_NAME);
    }
    
    return utmValue;
  }

  // ==========================================
  // 🎨 APLICAR ESTILOS NO FORMULÁRIO
  // ==========================================
  function applyFormStyles(targetForm, appEmbed, utmField, containerId) {
    const isMobile = window.innerWidth <= 768;
    let formStarted = false;
    const utmValue = getUTMValue();

    console.log("✅ [FORM MULTI] Aplicando estilos no formulário");
    console.log("   📦 Container ID:", containerId);
    console.log("   📍 Página:", window.location.pathname);

    // ==========================================
    // 🏷️ UTM - CAMPO OCULTO
    // ==========================================
    if (utmValue && utmField) {
      utmField.value = utmValue;
      utmField.dispatchEvent(new Event("input", { bubbles: true }));
      utmField.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("✅ [FORM MULTI] UTM aplicado:", utmValue);
    }

    // Oculta o campo UTM completamente
    if (utmField) {
      const utmWrapper = utmField.closest('[data-testid="form-field-wrapper"]');
      if (utmWrapper) {
        utmWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
      
      utmField.style.cssText = "display: none !important; visibility: hidden !important;";
      
      const utmLabel = appEmbed.shadowRoot.querySelector('label[for*="utm"]');
      if (utmLabel) {
        utmLabel.style.cssText = "display: none !important; visibility: hidden !important;";
      }
    }

    // ==========================================
    // 🎨 ESTILOS VIA ADOPTED STYLESHEETS
    // ==========================================
    const shadow = appEmbed.shadowRoot;

    if (shadow) {
      const sheet = new CSSStyleSheet();

      sheet.replaceSync(`
        /* ── FORM WRAPPER ── */
        .section-form {
          padding: ${isMobile ? '16px' : '15px 32px'};
           max-width: ${isMobile ? '85%' : '500px'} !important;
          margin: 0 auto;
          background: #f5f2ed;
          border-radius: 20px;
          font-family: 'Montserrat', sans-serif;
        }

        /* ── TÍTULO ── */
        h2._textHeading_2aowh_35 {
          font-size: ${isMobile ? '26px' : '32px'};
          color: #022D2F;
          font-weight: 400;
          text-transform: none;
          text-align: left;
          margin-bottom: 12px;
          line-height: 1.2;
          font-family: "El Messiri', serif
        }

        /* ── SUBTÍTULO / DESCRIÇÃO ── */
        ._textBody_2aowh_10 p {
          font-size: 18px;
          text-align: left;
          color: #022D2F;
          margin-bottom: 24px;
          font-family: "El Messiri', serif !important;
        }

        /* ── CAMPO NOME COMPLETO: ocupa 2 colunas ── */
        ._formFieldContainer_1mxsl_5:has(#first_name),
        ._formFieldContainer_1mxsl_5:has(#email),
        ._formFieldContainer_1mxsl_5:has(._formInputField_nag3b_7),
        ._selectContainer_12thd_6 {
          grid-column: 1 / span 2;
        }

        ._selectContainer_12thd_6:nth-child(2){
          max-width: 50%;
          background: red !important
        }

        form._formFieldset_cit2d_82{
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: end;
        }
    

        /* ── INPUTS BASE ── */
        ._formFieldContainer_1mxsl_5:has(#first_name):before{
          content: "Nome";
          font-size: 14px;
        }
        ._formFieldContainer_1mxsl_5:has(#email):before{
          content: "E-mail";
          font-size: 14px;
        }
        ._formFieldContainer_1mxsl_5:has(input[type="tel"])::before{
          content: "WhatsApp";
          font-size: 14px;
        }
        ._formFieldContainer_1mxsl_5:has([aria-labelledby="label-custom#cidade"])::before{
          content: "Cidade";
          font-size: 14px;
        }
        
      
      


        input[id="first_name"],
        input[id="email"],
        input[id="phone_number"],
        input[id="custom#cidade"] {
          background: #e8e4dd !important;
          border: 1.5px solid transparent !important;
          border-radius: 10px !important;
          color: #1a1a1a !important;
          font-family: 'Montserrat', sans-serif !important;
          font-size: 14px !important;
          padding: 14px 16px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          transition: border-color 0.25s, box-shadow 0.25s, background 0.25s !important;
          outline: none !important;
        }

        /* ── INPUTS PLACEHOLDER ── */
        input[id="first_name"]::placeholder,
        input[id="email"]::placeholder,
        input[id="phone_number"]::placeholder {
          color: #8a8278 !important;
          font-family: 'Montserrat', sans-serif !important;
          font-size: 14px !important;
        }

        /* ── INPUTS FOCUS ── */
        input[id="first_name"]:focus,
        input[id="email"]:focus,
        input[id="phone_number"]:focus {
          background: #ddd9d1 !important;
          border-color: #2d5a3d !important;
          box-shadow: 0 0 0 3px rgba(45, 90, 61, 0.12) !important;
        }

        /* ── LABELS ── */
        label {
          color: #6b6560 !important;
          font-family: 'Montserrat', sans-serif !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          margin-bottom: 4px !important;
          display: none !important;
        }

        /* ── BOTÃO DE PAÍS (phone) ── */
        button[class*="selectToggle"] {
          background: #e8e4dd !important;
          border: 1.5px solid transparent !important;
          border-radius: 10px !important;
          height: 100% !important;
          max-height: 50px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin-right: 6px !important;
          transition: background 0.2s !important;
        }

        button[class*="selectToggle"]:hover {
          background: #ddd9d1 !important;
        }

        /* ── TELEFONE: remove seletor de país ── */
        ._formPhoneInputContainer_piv1u_6 .phone-country-selector {
          display: none !important;
        }

        ._formPhoneInputContainer_piv1u_6 {
          grid-template-columns: 100% !important;
          grid-column: 1 / span 2;
        }

        /* ── SELECT / DROPDOWN ── */
        select,
        [class*="select"] {
          border: 1.5px solid transparent !important;
          border-radius: 10px !important;
          color: #1a1a1a !important;
          font-family: 'Montserrat' !important;
          font-size: 14px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          outline: none !important;
          cursor: pointer !important;
          transition: border-color 0.25s, background 0.25s !important;
        }

        select:focus,
        [class*="select"]:focus {
          background: #ddd9d1 !important;
          font-family: 'Montserrat' !important;
          border-color: #2d5a3d !important;
          box-shadow: 0 0 0 3px rgba(45, 90, 61, 0.12) !important;
        }

        p{
          font-family: 'Montserrat' !important;
        }

        /* ── BOTÃO DE ENVIO ── */
        button[data-testid="btn-form-submit"] {
          grid-column: 1 / span 2 !important;
          background: #022D2F !important;
          color: #ffffff !important;
          border: none !important;
          border-radius: 100px !important;
          font-family: 'Montserrat', sans-serif !important;
          font-weight: 700 !important;
          font-size: 15px !important;
          padding: 16px 32px !important;
          cursor: pointer !important;
          margin-top: 8px !important;
          letter-spacing: 0.3px !important;
          transition: background 0.25s, transform 0.15s, box-shadow 0.25s !important;
          box-shadow: 0 4px 16px rgba(26, 58, 46, 0.25) !important;
        }
          

        /* ── SUBMIT BUTTON TEXT FIX ── */
        ._formSubmitButton_cit2d_96 {
          color: #ffffff !important;
        }

        /* ── TEXTAREA ── */
        textarea[name="custom#mensagem"] {
          background: #e8e4dd !important;
          border: 1.5px solid transparent !important;
          border-radius: 10px !important;
          color: #1a1a1a !important;
          font-family: 'Montserrat', sans-serif !important;
          font-size: 14px !important;
          padding: 14px 16px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          transition: border-color 0.25s !important;
          outline: none !important;
          resize: vertical !important;
        }

        textarea[name="custom#mensagem"]:focus {
          background: #ddd9d1 !important;
          border-color: #2d5a3d !important;
          box-shadow: 0 0 0 3px rgba(45, 90, 61, 0.12) !important;
        }

        /* ── LABEL PHONE FIX ── */
        label[for="label-phone_number"] {
          transform: translateY(-10px) !important;
        }

        /* ── FIELD WRAPPERS ── */
        [data-testid="form-field-wrapper"] {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
        }

        /* ── MENSAGENS DE ERRO ── */
        [class*="error"],
        [class*="Error"] {
          color: #c0392b !important;
          font-size: 12px !important;
          font-family: 'Montserrat', sans-serif !important;
          margin-top: 4px !important;
        }

        section._formBannerContainer_z5ku3_1{
          background: #f5f2ed;
          padding: 30px;
          border-radius: 10px;
          border: 1px solid #fff;
        }

        h2._formBannerHeading_z5ku3_9{
          font-size: 0 !important;
        }
        h2._formBannerHeading_z5ku3_9::before{
          content: "Recebemos seu cadastro!";
          font-size: 22px;
          color: #022D2F;
          margin-bottom: 30px;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p{
          font-size: 0;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p::before{
          content: " Olá! Ficamos muito felizes com seu interesse em ser um parceiro LaDovas. Recebemos seus dados com sucesso. Nossa equipe vai analisar seu perfil e, em breve, entraremos em contato para liberar seu acesso exclusivo. Até logo!";
          font-size: 16px;
          color: #022D2F;
          }


         /* Estado */
        ._selectContainer_12thd_6:has([aria-controls="custom#estado_1-selector-dropdown"]) {
          grid-column: 1 !important;
        }

        /* Cidade */
        ._formFieldContainer_1mxsl_5:has([data-testid="field-custom#cidade"]){ 
            grid-column: 2 !important;
        }

        @media screen and (min-width: 1439px) and (max-width: 1600px){
          .section-form {
           max-width: 375px !important;
        padding: 21px;
          }
        }


        /* ── MOBILE ── */
        @media (max-width: 768px) {
          form[data-testid="form"] {
            grid-template-columns:1fr 1fr !important;
          }

          button[data-testid="btn-form-submit"] {
            grid-column: 1 / span 2 !important;
          }
        }
      `);

      shadow.adoptedStyleSheets = [
        ...shadow.adoptedStyleSheets,
        sheet
      ];

      const formWrapper = shadow.querySelector('section[data-sizing="form-wrapper"]');
      if (formWrapper) {
        formWrapper.classList.add('section-form');
      }
    }

        // ==========================================
// 🌐 TRADUÇÃO DE ERROS DE VALIDAÇÃO
// ==========================================
function translateFormErrors(shadow) {
  const translations = {
    // Erros de campo obrigatório
    'First name is required': 'Nome é obrigatório',
    'Last name is required': 'Sobrenome é obrigatório',
    'Phone number is required': 'Telefone é obrigatório',
    'Email is required': 'E-mail é obrigatório',
    'Email is invalid': 'E-mail é inválido',
    'Field is required': 'Campo obrigatório',
    'This field is required': 'Este campo é obrigatório',

    // Erros de formato
    'Please enter a valid email': 'Digite um e-mail válido',
    'Please enter a valid email address': 'Digite um e-mail válido',
    'Invalid email address': 'E-mail inválido',
    'Please enter a valid phone number': 'Digite um telefone válido',
    'Invalid phone number': 'Telefone inválido',

    // Outros
    'Please fill in this field': 'Preencha este campo',
    'Value is too short': 'Valor muito curto',
    'Value is too long': 'Valor muito longo',
  };

  function applyTranslations() {
    const errorElements = shadow.querySelectorAll(
      'output[role="alert"], ._formError_1mxsl_21, [class*="formError"]'
    );

    errorElements.forEach(el => {
      const original = el.textContent.trim();
      if (translations[original]) {
        el.textContent = translations[original];
      }
    });
  }

  // Aplica imediatamente
  applyTranslations();

  // Observa mudanças para traduzir erros que aparecem após submit
  const errorObserver = new MutationObserver(() => {
    applyTranslations();
  });

  errorObserver.observe(shadow, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

    if (shadow) {
  translateFormErrors(shadow);
}


    // ==========================================
    // 📝 INPUTS - APENAS EVENTOS DE TRACKING
    // ==========================================
    const allInputs = targetForm.querySelectorAll('input');
    console.log(`🔵 [FORM MULTI] ${allInputs.length} inputs encontrados`);

    allInputs.forEach(input => {
      input.addEventListener('focus', () => {
        if (!formStarted) {
          formStarted = true;

          console.log("🎯 [FORM MULTI] ========================================");
          console.log("🎯 [FORM MULTI] USUÁRIO COMEÇOU A PREENCHER!");
          console.log("🎯 [FORM MULTI] Form ID: 918917");
          console.log("🎯 [FORM MULTI] Container:", containerId);
          console.log("🎯 [FORM MULTI] Página:", window.location.pathname);
          console.log("🎯 [FORM MULTI] ========================================");

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'initiate_form',
            'form_id': FORM_ID,
            'form_type': 'standard',
            'container_id': containerId,
            'page_url': window.location.href,
            'timestamp': new Date().getTime()
          });
        }
      }, { once: true });
    });

    // ==========================================
    // 🚀 BOTÃO DE ENVIO - EVENTOS
    // ==========================================
    const submitBtn = targetForm.querySelector('button[data-testid="btn-form-submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('mouseenter', () => {
        submitBtn.style.transform = "translateY(-2px)";
      });

      submitBtn.addEventListener('mouseleave', () => {
        submitBtn.style.transform = "translateY(0)";
      });

      submitBtn.addEventListener("click", () => {
        const nome     = targetForm.querySelector('#first_name')?.value || '';
        const email    = targetForm.querySelector('#email')?.value || '';
        const whatsapp = targetForm.querySelector('#phone_number')?.value || '';

        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] FORMULÁRIO ENVIADO!");
        console.log("🚀 [FORM MULTI] Form ID: 918917");
        console.log("🚀 [FORM MULTI] Container:", containerId);
        console.log("🚀 [FORM MULTI] Página:", window.location.pathname);
        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] Dados capturados:");
        console.log("   📝 Nome:", nome);
        console.log("   📧 Email:", email);
        console.log("   📱 WhatsApp:", whatsapp);
        console.log("   🏷️ UTM:", utmValue);
        console.log("🚀 [FORM MULTI] ========================================");
      });
    }

    // Marca como processado usando WeakSet
    processedForms.add(targetForm);
    console.log("✅ [FORM MULTI] Formulário configurado com sucesso!");
  }

  // ==========================================
  // 🔍 PROCESSAR TODOS OS FORMULÁRIOS
  // ==========================================
  const processAllForms = () => {
    let formsFound = 0;
    let formsProcessed = 0;

    CONTAINER_IDS.forEach(containerId => {
      const container = document.querySelector(containerId);

      if (!container) return;

      const appEmbed = container.querySelector('#app-embed');
      
      if (!appEmbed || !appEmbed.shadowRoot) return;

      const targetForm = appEmbed.shadowRoot.querySelector('form');
      const utmField   = appEmbed.shadowRoot.querySelector('#custom\\#utm');

      if (!targetForm) return;

      formsFound++;

      if (processedForms.has(targetForm)) return;

      applyFormStyles(targetForm, appEmbed, utmField, containerId);
      formsProcessed++;
    });

    if (formsProcessed > 0) {
      console.log(`✅ [FORM MULTI] ${formsProcessed} formulário(s) processado(s) nesta execução`);
    }

    return formsProcessed > 0;
  };

  // ==========================================
  // 👀 OBSERVER PERMANENTE - MONITORA DOM
  // ==========================================
  const observer = new MutationObserver(() => {
    processAllForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ==========================================
  // 🔄 LISTENER PARA MUDANÇAS DE PÁGINA
  // ==========================================
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      console.log("🔄 [FORM MULTI] Mudança de página detectada:", url);
      setTimeout(() => processAllForms(), 500);
      setTimeout(() => processAllForms(), 1000);
      setTimeout(() => processAllForms(), 2000);
    }
  }).observe(document, { subtree: true, childList: true });

  // Para navegação com History API
  const originalPushState    = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] PushState detectado");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  };

  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] ReplaceState detectado");
    setTimeout(() => processAllForms(), 500);
  };

  window.addEventListener('popstate', () => {
    console.log("🔄 [FORM MULTI] Popstate detectado (navegação voltar/avançar)");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  });

  // ==========================================
  // 📱 LISTENER PARA RESIZE (Mobile/Desktop)
  // ==========================================
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      console.log("📱 [FORM MULTI] Resize detectado, reprocessando formulários");
      processAllForms();
    }, 250);
  });

  // ==========================================
  // 🚀 INICIALIZAÇÃO
  // ==========================================
  processAllForms();
  setTimeout(() => processAllForms(), 500);
  setTimeout(() => processAllForms(), 1000);
  setTimeout(() => processAllForms(), 2000);
  setTimeout(() => processAllForms(), 3000);

  console.log("✅ [FORM MULTI] Sistema multi-formulários ativado!");
  console.log("📦 [FORM MULTI] Monitorando", CONTAINER_IDS.length, "container(s):");
  CONTAINER_IDS.forEach((id, index) => {
    console.log(`   ${index + 1}. ${id}`);
  });
  console.log("📍 [FORM MULTI] Página inicial:", window.location.pathname);

  window.reprocessAllForms = () => {
    console.log("🔧 [FORM MULTI] Reprocessamento manual solicitado");
    processAllForms();
  };

  window.addFormContainer = (newContainerId) => {
    if (!CONTAINER_IDS.includes(newContainerId)) {
      CONTAINER_IDS.push(newContainerId);
      console.log("➕ [FORM MULTI] Novo container adicionado:", newContainerId);
      processAllForms();
    } else {
      console.log("⚠️ [FORM MULTI] Container já existe na lista:", newContainerId);
    }
  };

})();